export default __webpack_public_path__ + "891f7dc057d494bb80a436af5f9e800e.png";